import { Button, Modal, Toast } from "@heroui/react";

import { useDeleteBanner } from "../use-banners";
import { BannerEntity } from "../types";

type Props = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  banner: BannerEntity;
};

export function DeleteBannerModal({ isOpen, onOpenChange, banner }: Props) {
  const { mutateAsync, isPending } = useDeleteBanner();

  const onConfirm = () => {
    mutateAsync({ id: banner.id })
      .then(() => {
        Toast.toast.success("Баннер удалён");
        onOpenChange(false);
      })
      .catch(() => {
        Toast.toast.danger("Ошибка при удалении баннера");
      });
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Backdrop isDismissable>
        <Modal.Container placement="center">
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Heading>Подтверждение удаления</Modal.Heading>
            </Modal.Header>
            <Modal.Body>
              Удалить баннер{" "}
              <span className="font-semibold">«{banner.title}»</span>?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="ghost" onPress={() => onOpenChange(false)}>
                Отмена
              </Button>
              <Button variant="danger" isPending={isPending} onPress={onConfirm}>
                Удалить
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
}
